import {
  ChartIndicator,
  ConnectionIndicator,
  MessagesIndicator,
  PriorityIndicator,
  RecommendationPriorityIndicator,
  StatusIndicator,
  TablePriority,
  TendencyIndicator,
  UsersIndicator,
} from './components';

const Indicator = {
  Table: TablePriority,
  Status: StatusIndicator,
  Users: UsersIndicator,
  Connection: ConnectionIndicator,
  Chart: ChartIndicator,
  Tendency: TendencyIndicator,
  Messages: MessagesIndicator,
  Priority: PriorityIndicator,
  RecommendationPriority: RecommendationPriorityIndicator,
};

export { Indicator };
